/**
 * Created by Greg on 4/1/2016. No Joke.
 */
import {combineReducers} from 'redux'

import netVisInteract from './netInteractReducer';
import net from './netReducer';
import netAction from './netActionReducer';
import uiState from './uiStateReducer';

/*
 My application state looks something like this
 */
// export const initialState = {
//     net: netValidate(JSON.stringify(smallExNet)).netObj,
//     demands: {id: null, desc: null, demandList: []},
//     paths: [],  // a list of path collections of the form: {id: null, desc: null, pathList: []}
//     netAction: {type: NET_ACTION.NEW},
//     netVisInteract: {
//         mouseMode: "view", showDemands: true,
//         linkWidth: 2, demandWidth: 4,
//         capVis: {
//             showCap: true, minWidth: 4, maxWidth: 20, updateCap: 0
//         },
//         selectedNodes: [],
//         selectedLinks: [],
//     },
//     uiState: { // We need to keep track of lots of dialogs here
//         showComputeServeModal: false
//     }
//     compServe: { namePort }
// };

function compServe(state={namePort: "localhost:1517"}, action) {
    switch (action.type) {
        case 'ASSIGN_SERVER':
            return {namePort: action.namePort};
        default:
            return state;
    }
}

function demands(state = {id: null, desc: null, demandList: []}, action) {
    switch (action.type) {
        case 'DEMANDS_LOAD':
            return action.demandObj;
        case 'DEMANDS_CLEAR':
            return {id: null, desc: null, demandList: []};
        default:
                return state;
    }

}

function paths(state = [], action) {
    switch (action.type) {
        case 'PATH_COLLECTION_ADD':
            return state.concat([action.pathObj]);
        case 'PATHS_UPDATE':
            return action.paths;
        default:
            return state;
    }
}





const netVizApp = combineReducers({
    net, demands, paths, netAction, netVisInteract, uiState, compServe
});

export default netVizApp;





// WEBPACK FOOTER //
// ./src/reducers/reducers.js